import { Self, Directive, HostBinding } from "@angular/core";
import { NgControl } from "@angular/forms";

// Taken from: https://stackoverflow.com/questions/44119219/angular-form-validation-and-bootstrap-styles#answer-48004959
@Directive({
    standalone: false,
    selector: '[formControlName],[ngModel],[formControl]',
})
export class ApplyErrorClassDirective {

    constructor( @Self() private cd: NgControl) { }

    @HostBinding('class.is-invalid')
    get isInvalid(): boolean {
        const control = this.cd.control;
        return control ? control.invalid && control.touched : false;
    }
}
